import { render, staticRenderFns } from "./compClubRebateConfig.vue?vue&type=template&id=c548a666&"
import script from "./compClubRebateConfig.vue?vue&type=script&lang=js&"
export * from "./compClubRebateConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports